/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const GetJiraConfig = {
  id: 'config.jira.get',
  tag: 'Common',
  summary: 'Get Jira configuration',
  description: 'Retrieve Jira configuration',
  method: 'get',
  route: () => `/config/jira/status`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.object({
            status: z.boolean(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
